import { EntityTemplateVariables, TemplateVariable } from '@tools/interfaces/template';
import { getContactFieldsForEntity } from './template-contact';
import { getBookingFieldsForEntity } from './00-common-booking-fields';
import { templateBookingEvent } from './template-booking-events';
import { getResourceFieldsForEntity } from './template-resource';

// import { templateBookingEvent } from './template-booking-events';

export const getContractFieldsForEntity = (entity: string): TemplateVariable[] => {
  return [
    {
      label: 'templates.contracts.code.label',
      contentValue: `{{ ${entity}contract.code }}`,
      description: 'templates.contracts.code.description',
    },
    {
      label: 'templates.contracts.name.label',
      contentValue: `{{ ${entity}contract.name }}`,
      description: 'templates.contracts.name.description',
    },
    {
      label: 'templates.contracts.contract_type.label',
      contentValue: `{{ ${entity}contract.contract_type }}`,
      description: 'templates.contracts.contract_type.description',
    },
    {
      label: 'templates.contracts.contract_date.label',
      contentValue: `{{ ${entity}contract.contract_date | date("d/m/Y") }}`,
      description: 'templates.contracts.contract_date.description',
    },
    {
      label: 'templates.contracts.period_start_date.label',
      contentValue: `{{ ${entity}contract.period_start_date | date("d/m/Y") }}`,
      description: 'templates.contracts.period_start_date.description',
    },
    {
      label: 'templates.contracts.period_end_date.label',
      contentValue: `{{ ${entity}contract.period_end_date | date("d/m/Y") }}`,
      description: 'templates.contracts.period_end_date.description',
    },
    {
      label: 'templates.contracts.status.label',
      contentValue: `{{ ${entity}contract.status }}`,
      description: 'templates.contracts.status.description',
    },
    {
      label: 'templates.contracts.booking_total_amount.label',
      contentValue: `{{ ${entity}contract.booking_total_amount | format_currency('EUR', {decimal_always_shown: true, fraction_digit: 2}, locale='fr') }}`,
      description: 'templates.contracts.booking_total_amount.description',
    },
    {
      label: 'templates.contracts.represented_by.label',
      contentValue: `{{ ${entity}contract.represented_by }}`,
      description: 'templates.contracts.represented_by.description',
    },
    // {
    //   label: 'templates.contracts.document_template_body.label',
    //   contentValue: `{{ ${entity}contract.document_template_body }}`,
    //   description: 'templates.contracts.document_template_body.description',
    // },
  ];
};

export const templateContract: EntityTemplateVariables = {
  fields: getContractFieldsForEntity(''),
  related: [
    {
      relationName: 'contact',
      relationType: 'simple',
      label: 'templates.contracts.contact.label',
      description: 'templates.contracts.contact.description',
      fields: getContactFieldsForEntity('contract.'),
    },
    {
      relationName: 'templateHelper',
      relationType: 'simple',
      label: 'templates.bookings.template_helper.label',
      description: 'templates.bookings.template_helper.description',
      fields: [
        {
          label: 'templates.template_helper.table_of_booking_events_by_months.label',
          contentValue:
            '{{ templateHelper.table_of_booking_events_by_months(contract.booking_ids) | raw }}',
          description: 'templates.template_helper.table_of_booking_events_by_months.description',
        },
        {
          label: 'templates.template_helper.table_of_booking_events_summary.label',
          contentValue:
            '{{ templateHelper.table_of_booking_events_summary(contract.booking_ids) | raw }}',
          description: 'templates.template_helper.table_of_booking_events_summary.description',
        },
        {
          label: 'templates.template_helper.table_of_booking_events_summary_wo_subventions.label',
          contentValue:
            '{{ templateHelper.table_of_booking_events_summary_wo_subventions(contract.booking_ids) | raw }}',
          description:
            'templates.template_helper.table_of_booking_events_summary_wo_subventions.description',
        },
        // TODO: Commented because it is not implemented yet
        // {
        //   label: 'templates.template_helper.table_of_booking_events_grouped_by_resources.label',
        //   contentValue:
        //     '{{ templateHelper.table_of_booking_events_grouped_by_resources(contract.booking_ids) | raw }}',
        //   description:
        //     'templates.template_helper.table_of_booking_events_grouped_by_resources.description',
        // },
        {
          label: 'templates.template_helper.list_of_unique_resources_of_multiple_bookings.label',
          contentValue:
            '{{ templateHelper.list_of_unique_resources_of_multiple_bookings(contract.booking_ids) | raw }}',
          description:
            'templates.template_helper.list_of_unique_resources_of_multiple_bookings.description',
        },
      ],
    },
  ],
  relatedInLoop: [
    {
      relationName: 'booking',
      relationType: 'inLoop',
      label: 'templates.contract.bookings.label',
      description: 'templates.contracts.bookings.description',
      blockStartValue: '{% for booking in contract.bookings %}',
      contentValue: '{# Add some booking fields #}',
      blockEndValue: '{% endfor %}',
      fields: getBookingFieldsForEntity(''),
    },
    {
      relationName: 'resources',
      relationType: 'inLoop',
      label: 'templates.contracts.resources.label',
      description: 'templates.contracts.resources.description',
      blockStartValue:
        '{% for booking in contract.bookings %}\n{% for resource in booking.resources %}',
      contentValue: '{# Add some Resource fields #}',
      blockEndValue: '{% endfor %}\n{% endfor %}',
      fields: getResourceFieldsForEntity(''),
    },
    {
      relationName: 'bookingEvent',
      relationType: 'inLoop',
      label: 'templates.contract.booking_events.label',
      description: 'templates.contracts.booking_events.description',
      blockStartValue:
        '{% for booking in contract.bookings %}\n{% for booking_event in booking.bookingEvents %}',
      contentValue: '{# Add some bookingEvent fields #}',
      blockEndValue: '{% endfor %}\n{% endfor %}',
      fields: templateBookingEvent.fields,
    },
  ],
};
